import { matchVersion } from '../../utils';
import __regexp from './__ios-regexp';
/** Detect the iOS Version */
export default function isIOSVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 2,
			transformMatch: function (v) {
				return v.replace(/_/g, '.');
			}
		});
	};
}
